import { z } from "zod";
import { UIElementType } from "../../../../AppConstants";
import { t } from "i18next";

const getPezodeSchema = (lookUpData, formStateData, editPezodeId = null, availableInfestation = []) => {

    console.log("formStateData" + JSON.stringify(formStateData));
    return z.object({
        Location: z
            .object({
                id: z.string(),
                label: z.string(),
            })
            .nullable()
            .refine((value) => value !== null && value?.id !== null, {
                message: "Location is required",
            }).describe(
                JSON.stringify({
                    elementType: UIElementType.DROPDOWN,
                    inputLabel: t("createPezode.location"),
                    isMultiSelect: false,
                    isRequired: true,
                    options: lookUpData.location ? lookUpData.location : [],
                    isDisabled: !!editPezodeId
                })
            ),
        Zone: z
            .object({
                id: z.string(),
                label: z.string(),
            })
            .nullable()
            .describe(
                JSON.stringify({
                    elementType: UIElementType.DROPDOWN,
                    inputLabel: t("createPezode.zone"),
                    isMultiSelect: false,
                    isRequired: false,
                    options: lookUpData.zone ? lookUpData.zone : [],
                    isDisabled: !formStateData?.Location?.id || !!editPezodeId
                })
            ),

        Pest: z
            .object({
                id: z.number(),
                label: z.string(),
            })
            .nullable()
            .refine((value) => value !== null && value?.id !== null, {
                message: "Pest is required",
            })
            .describe(
                JSON.stringify({
                    elementType: UIElementType.DROPDOWN,
                    inputLabel: t("createPezode.pest"),
                    isMultiSelect: false,
                    isRequired: true,
                    options: lookUpData.pest ? lookUpData.pest : [],
                    isDisabled: !formStateData?.Location?.id || !!editPezodeId
                })
            ),
        Device: z
            .object({
                id: z.string(),
                label: z.string(),
            })
            .nullable()
            .refine((value) => value !== null && value?.id !== null, {
                message: "Device is required",
            }).describe(
                JSON.stringify({
                    elementType: UIElementType.DROPDOWN,
                    inputLabel: t("createPezode.device"),
                    isMultiSelect: false,
                    isRequired: true,
                    options: lookUpData.device ? lookUpData.device : [],
                    isDisabled: !formStateData?.Location?.id || !!editPezodeId
                })
            ),
        InputUnit: z
            .object({
                id: z.string(),
                label: z.string(),
            })
            .nullable()
            .refine((value) => value !== null && value?.id !== null, {
                message: "Input unit is required",
            }).describe(
                JSON.stringify({
                    elementType: UIElementType.DROPDOWN,
                    inputLabel: t("createPezode.inputUnit"),
                    isMultiSelect: false,
                    isRequired: true,
                    options: lookUpData.inputUnit ? lookUpData.inputUnit : [],
                    isDisabled: !formStateData?.Location?.id
                })
            ),
        iCabsProductCode: z
            .object({
                id: z.string(),
                label: z.string(),
            })
            .nullable()
            .refine((value) => value !== null && value?.id !== null, {
                message: "iCabs product code is required",
            }).describe(
                JSON.stringify({
                    elementType: UIElementType.DROPDOWN,
                    inputLabel: t("createPezode.icabsProductCode"),
                    isMultiSelect: false,
                    isRequired: true,
                    options: lookUpData.iCabsProductCode ? lookUpData.iCabsProductCode : [],
                    isDisabled: !formStateData?.Location?.id
                })
            ),

        infestationLevel: z
            .array(
                z.object({
                    id: z.string(),
                    label: z.string(),
                })
            )
            .refine((value) => value !== null && value.length > 0, {
                message: "Infestation level is required",
            })
            .describe(
                JSON.stringify({
                    elementType: UIElementType.CHECKBOX,
                    inputLabel: t("createPezode.infestationLevel"),
                    isMultiSelect: true,
                    isRequired: true,
                    data: lookUpData.infestationLevel
                        ? lookUpData.infestationLevel.map((item) => ({
                            ...item,
                            disabled: availableInfestation.includes(item.id)
                        }))
                        : [],
                    isDisabled: !formStateData?.Location?.id ||
                        !formStateData?.Pest?.id ||
                        !formStateData?.Device?.id || !!editPezodeId,
                    selectedValues: formStateData?.infestationLevel
                })
            ),


        iCabsProductDetails: z
            .array(
                z.object({
                    id: z.string(),
                    label: z.string(),
                })
            )
            .nullable()
            .describe(
                JSON.stringify({
                    elementType: UIElementType.DROPDOWN,
                    inputLabel: t("createPezode.icabsProductDetail"),
                    isMultiSelect: true,
                    isRequired: false,
                    options: lookUpData.iCabsProductDetails ? lookUpData.iCabsProductDetails : [],
                    isDisabled: !formStateData?.Location?.id ||
                        !formStateData?.Pest?.id ||
                        !formStateData?.Device?.id ||
                        !formStateData?.iCabsProductCode?.id,
                    selectedValues: formStateData?.iCabsProductDetails
                })
            ),

        Toxic: z
            .string()
            .describe(JSON.stringify({
                elementType: UIElementType.RADIOBUTTON,
                inputLabel: t("createPezode.toxic"),
                isRequired: true,
                isDisabled: !formStateData?.Location?.id ||
                    !formStateData?.Pest?.id ||
                    !formStateData?.Device?.id ||
                    !formStateData?.iCabsProductCode?.id || !!editPezodeId
            })
            )
            .transform((val) => {
                if (typeof val !== "string") return val; // If it's not a string, return as is
                return val.toLowerCase() === "true";
            }),
        ServicesInVantage: z
            .string()
            .describe(JSON.stringify({
                elementType: UIElementType.RADIOBUTTON,
                inputLabel: t("createPezode.serviceInVantage"),
                isRequired: true,
                isDisabled: !formStateData?.Location?.id ||
                    !formStateData?.Pest?.id ||
                    !formStateData?.Device?.id ||
                    !formStateData?.iCabsProductCode?.id
            })
            )
            .transform((val) => {
                if (typeof val !== "string") return val; // If it's not a string, return as is
                return val.toLowerCase() === "true";
            })

    });
};

const getPezodeDefaultValue = (value = null) => {
    return {
        Location: value && value.Location ? value.Location : null,
        Zone: value && value.Zone ? value.Zone : null,
        Pest: value && value.Pest ? value.Pest : null,
        Device: value && value.Device ? value.Device : null,
        InputUnit: value && value.InputUnit ? value.InputUnit : null,
        iCabsProductCode: value && value.iCabsProductCode ? value.iCabsProductCode : null,
        iCabsProductDetails: value && value.iCabsProductDetails ? value.iCabsProductDetails : null,
        infestationLevel: value && value.infestationLevel ? value.infestationLevel : null,
        Toxic: value ? (value?.Toxic === true || value?.Toxic === "true" ? "true" : "false") : "false",
        ServicesInVantage: value ? (value?.ServicesInVantage === true || value?.ServicesInVantage === "true" ? "true" : "false") : "false",
    };
};

const getPezodeAPIPostSchema = (countryCode, businessCode) => {
    return {
        countryCode: countryCode,
        businessCode: businessCode,
        pezodein: [
            {
                PezodeId: "",
                Id: "",
                LocationId: null,
                ZoneLocationId: null,
                ICABSPestCode: "",
                PestCode: "",
                DeviceId: "",
                InputUnit: "",
                ICABSProductCode: "",
                infestationLevelId: [],
                ICABSProductDetailCode: "",
                Toxic: false,
                ServicesInVantage: false,
                ImpactPercentage: 99999,
                Shock: false,
                pezoderange: [
                    {
                        Formula: "",
                        MinimumInputValue: "",
                        MaximumInputValue: "",
                        OutputUnitValue: "",
                        OutputValue: "",
                        OutputUnit: "",
                        Summation: "",
                        Deleted: false
                    },
                ],
                consumableproductmap: [],
                Deleted: false,
                CountryCode: countryCode,
                BusinessCode: businessCode,
            },
        ],
    };
};

const getPezodeAPIDeleteSchema = (countryCode, businessCode) => {
    return {
        countryCode: countryCode,
        businessCode: businessCode,
        pezodein: [
            {
                PezodeId: "",
                Id: "",
                Deleted: false,
                CountryCode: countryCode,
                BusinessCode: businessCode
            },
        ],
    };
};

const getPezodeAuditInfoSchema = () => {
    return {
        auditInfo: [
            {
                Location: "Pezode",
                LocationKey: "",
                Action: null,
                shortDesc: null,
                currentState: null,
                previousState: null,
            },
        ],
    };
};



export {
    getPezodeSchema,
    getPezodeDefaultValue,
    getPezodeAPIPostSchema,
    getPezodeAPIDeleteSchema,
    getPezodeAuditInfoSchema
};
